import axios from 'axios';
import { Bulletin, BulletinResum, TableauRemuneration, JobStatut } from '../types';

const BASE = '/api/v1/paie/bulletins';

export const bulletinsApi = {
  creer: (data: { idEmploye: string; mois: number; annee: number; avanceAcompte?: number; oppositions?: number; taxesTemporaires?: number }) =>
    axios.post(BASE, data).then(r => r.data?.data ?? r.data) as Promise<Bulletin>,

  lancerMasse: (data: { mois: number; annee: number; idEmployes?: string[]; idProjet?: string; sansProjet?: boolean }) =>
    axios.post(`${BASE}/masse`, data).then(r => r.data?.data ?? r.data) as Promise<{ jobId: string; message: string }>,

  obtenirParId: (id: string) =>
    axios.get(`${BASE}/${id}`).then(r => r.data?.data ?? r.data),

  changerStatut: (idBulletin: string, statut: 'BROUILLON' | 'GENERE' | 'VALIDE' | 'PAYE') =>
    axios.patch(`${BASE}/${idBulletin}/statut`, { statut }).then(r => r.data?.data ?? r.data),

  changerStatutMasse: (mois: number, annee: number, statut: 'VALIDE' | 'PAYE') =>
    axios.patch(`${BASE}/masse/statut`, { mois, annee, statut }).then(r => r.data?.data ?? r.data),

  tableau: (annee: number, mois: number) =>
    axios.get(`${BASE}/tableau/${annee}/${mois}`).then(r => r.data?.data ?? r.data) as Promise<TableauRemuneration>,

  telecharger: async (idBulletin: string) => {
    try {
      const r = await axios.get(`${BASE}/${idBulletin}/telecharger`, { responseType: 'blob' });
      return r.data as Blob;
    } catch (err: any) {
      // Quand responseType:'blob', les erreurs HTTP sont aussi des Blobs — on les décode
      if (err?.response?.data instanceof Blob) {
        const text = await err.response.data.text();
        try {
          const json = JSON.parse(text);
          throw Object.assign(new Error(json.message || 'Erreur serveur'), { response: { data: json } });
        } catch (parseErr) {
          if (parseErr instanceof SyntaxError) throw new Error(text || 'Erreur lors du téléchargement');
          throw parseErr;
        }
      }
      throw err;
    }
  },

  telechargerPDF: async (idBulletin: string) => {
    try {
      const r = await axios.get(`${BASE}/espace-salarie/mes-bulletins/${idBulletin}/telecharger`, { responseType: 'blob' });
      return r.data as Blob;
    } catch (err: any) {
      if (err?.response?.data instanceof Blob) {
        const text = await err.response.data.text();
        try {
          const json = JSON.parse(text);
          throw Object.assign(new Error(json.message || 'Erreur serveur'), { response: { data: json } });
        } catch (parseErr) {
          if (parseErr instanceof SyntaxError) throw new Error(text || 'Erreur lors du téléchargement');
          throw parseErr;
        }
      }
      throw err;
    }
  },

  statutJob: (jobId: string) =>
    axios.get(`${BASE}/jobs/${jobId}`).then(r => r.data?.data ?? r.data) as Promise<JobStatut>,

  listerParPeriode: (annee: number, mois: number) =>
    axios.get<{ succes: boolean; data: BulletinResum[] }>(BASE, { params: { annee, mois } }).then(r => r.data?.data ?? []),

  supprimer: (idBulletin: string) =>
    axios.delete(`${BASE}/${idBulletin}`).then(r => r.data),
};
